import styled from '@emotion/styled';

const BasicWrapper = ({ children, ...rest }) => (children ? <span {...rest}>{children}</span> : null);

export const TextStyled = styled(BasicWrapper)`
    background-color: rgb(238, 238, 238);
    color: black;
    font-weight: 500;
`;

export const ButtonPanel = styled.div`
    display: flex;
    justify-content: center;
`;

export const Box = styled.div`
    border-top: 1px solid lightgrey;
    padding: 2rem 0;
    border-bottom: 1px solid lightgrey;
    /* margin-bottom: 2rem; */
`;
